/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Tea_PurchaseInputs */

const vi_pl_pnk_tea_purchase = /** @type {(inputs: Pl_Pnk_Tea_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua`)
};

/**

* @param {Pl_Pnk_Tea_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_tea_purchase = /** @type {((inputs?: Pl_Pnk_Tea_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Tea_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_tea_purchase(inputs)
});